import styles from "../../../styles/module/news-unique.module.css";
import { useCallback } from "react";
import api from "../../../services/api";
import Loading from "../others/Loading";
import { useQuery } from "react-query";
import { urlADM, urlEmDeploy } from "../../../services/variables";
import { PiEyesFill } from "react-icons/pi";
import { MdDateRange } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa6";
import CarouselImageNews from "../img/CarouselImageNews";
import { categoryColors } from "../../../utils";
import { LuFlag } from "react-icons/lu";

export default function UniqueNews({ idNoticia }) {
  const generateWhatsAppLink = useCallback(() => {
    return `${urlEmDeploy}/noticia/${idNoticia}`;
  }, [idNoticia]);

  const { data, isLoading, isError } = useQuery(
    `news-${idNoticia}`,
    async () => {
      const response = await api.post(`/news/unique/${idNoticia}`);
      return response.data.res;
    },
    { staleTime: 5 * 60 * 1000, cacheTime: 10 * 60 * 1000 }
  );

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <p>Erro ao carregar as notícias destaques...</p>;
  }

  const imgArray =
    data[0].MULTIPLE_IMG.length > 1
      ? [data[0].IMG, ...data[0].MULTIPLE_IMG]
      : [data[0].IMG];

  return (
    <div className={styles.container}>
      {data &&
        data.map((news) => (
          <div key={news.ID} className={styles.newsItem}>
            <div className={`${styles.header} ${styles.ajuste}`}>
              <h2 className={styles.title}>{news.TITULO}</h2>
            </div>
            <div className={`${styles.metaInfo} ${styles.ajuste}`}>
              <p className={styles.category}>
                <span>
                  <LuFlag />
                </span>
                <span>Categoria:</span>
                <span
                  className={styles.category_item}
                  style={{ background: categoryColors[news.CATEGORIA] }}
                >
                  {news.CATEGORIA}
                </span>{" "}
              </p>
              <p className={styles.date}>
                <MdDateRange /> Data:{" "}
                {new Date(news.DATA_POST).toLocaleDateString("pt-br")}
              </p>
              <p className={styles.views}>
                <span>{news.VISUALIZACAO} visualizações</span>{" "}
                <PiEyesFill size={18} />
              </p>
            </div>

            <div className={styles.imageWrapper}>
              <CarouselImageNews img={imgArray} />
            </div>

            <div className={`${styles.share_social} ${styles.ajuste}`}>
              <span>Compartilhe</span>
              <div>
                <a
                  href={`https://wa.me/?text=${encodeURIComponent(
                    generateWhatsAppLink()
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.whats}
                >
                  <FaWhatsapp className={styles.whats_icon} />
                </a>

                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    window.location.href
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.face}
                >
                  <FaFacebook className={styles.face_icon} />
                </a>
              </div>
            </div>
            <div
              className={`${styles.content} ${styles.ajuste}`}
              dangerouslySetInnerHTML={{ __html: news.CORPO_TEXTO }}
            />

            {news.ARQUIVO && (
              <a
                className={styles.anexo_file}
                target="_blank"
                rel="noreferrer"
                href={
                  urlADM +
                  `/downloads/other?n=${news.CNPJ.replaceAll("-", "")
                    .replaceAll("/", "")
                    .replaceAll(".", "")}&a=${news.ARQUIVO}&p=noticia`
                }
              >
                Clique aqui para baixar o anexo
              </a>
            )}

            {news.VIDEO && (
              <div className={styles.videoWrapper}>
                <iframe
                  width="560"
                  height="315"
                  className={styles.video}
                  src={news.VIDEO}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}
